import React, {FC, ReactElement, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {Baseline} from '../../Layout/Grid'
import CenteredModal, {WideModalContent} from '../../Molecules/Modals/Modals'

import {IconText} from '../../Atoms/IconText'
import {IconButton} from '../../Atoms/Buttons'
import {IconCloseSmall} from '../../../Assets/Icons/TinyIcons'

import AddAsset from './AddAsset'
import {AssetCategory, AssetWidgetProps} from './types'
import {AssetData, AssetType} from '../../../state/rest'
import styled from 'styled-components'
import {SharedIcon, IconPalette} from '../../../sharedComponents/components'

const DocumentList = styled.ul`
  margin: 0;
  padding: 0;
`

const DocumentItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

/**
 * Mirrors AssetWidget but for ONE document (PDF/Word) per task.
 */
const DocumentWidget: FC<AssetWidgetProps> = (props): ReactElement => {
  const {t} = useTranslation(['tasks', 'assets'])
  const [showUploader, toggleShowUploader] = useState(false)

  const onAddClick = (asset?: AssetData) => {
    if (asset) {
      props.handleAdd(asset)
      toggleShowUploader(false)
    }
  }

  const createDocList = (doc: AssetData) => {
    return (
      <DocumentList>
        <DocumentItem key={doc.id}>
          {doc.name}
          <IconButton
            icon={<IconCloseSmall />}
            buttonProps={{
              className: 'removeIcon',
              onClick: () => props.handleRemove(doc.id)
            }}
          />
        </DocumentItem>
      </DocumentList>
    )
  }

  const savedDocs = (props.savedAssets || []).filter(a => a.assetType === AssetType.DOCUMENT)
  const doc = savedDocs[0]
  const hasDoc = !!doc

  return (
    <Baseline>
      <IconText
        icon={<SharedIcon icon={IconPalette.Document} width="15" height="15" />}
        text={hasDoc && doc ? createDocList(doc) : t('tasks:labels.addDocument', 'Add document')}
        onClick={() => toggleShowUploader(!hasDoc && !showUploader)}
      />

      <CenteredModal isOpen={showUploader}>
        <WideModalContent>
          <AddAsset
            label={t(
              'tasks:labels.documentInfo',
              'You can add one image, link and document per task. Supported document formats are PDF and Word.'
            )}
            title={t('tasks:labels.addDocument', 'Add document')}
            acceptedTypes="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.doc,.docx"
            tabContents={[{title: t('tasks:labels.addDocument', 'Add document'), assetType: AssetType.DOCUMENT}]}
            handleClose={toggleShowUploader}
            handleAddSelected={onAddClick}
            assetCategory={AssetCategory.task}
          />
        </WideModalContent>
      </CenteredModal>
    </Baseline>
  )
}

export default DocumentWidget
